export const name = 'gzSaveDialogController';
export default function gzSaveDialogController(
  rnHttp,
  $mdDialog,
  $mdToast,
  $filter,
  filters,
  pairingId,
  $gzAnalytics
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const PORTAL_SERVICE_NAME = 'portal_service';
  const FILTERS_PATH = 'filters';

  /* jshint validthis: true */
  var vm = this;

  vm.sending = false;
  vm.filter = filters;
  vm.editForm = null;
  vm.save = save;
  vm.cancel = cancel;
  vm.disableSubmit = disableSubmit;

  activate();

  ////////////////

  function activate() {
  }

  function save() {
    vm.sending = true;
    vm.errorMessageKey = null;
    let filterToSave = {
      name: vm.filter.name,
      shared: false,
      pairingId: pairingId
    };

    _.set(filterToSave, 'namedFilter', _.cloneDeep(vm.filter.mergedFilter));
    if (vm.filter.quickFilter) {
      _.set(filterToSave, 'quickFilter', _.cloneDeep(vm.filter.quickFilter));
    }

    return rnHttp.post(PORTAL_SERVICE_NAME, FILTERS_PATH, filterToSave).then((serverFilter) => {
      if(serverFilter && serverFilter.data){
        let display = {
          title: serverFilter.data.name
        };
        _.set(serverFilter.data, 'namedFilter.display', display);
        if (serverFilter.data.userFilter) {
          delete serverFilter.data.userFilter;
        }

        $mdDialog.hide(serverFilter.data);
        let message = $filter('translate')('uxf.uxf.Filter_Saved');
        $mdToast.showSimple(message);
        var filterData = [];
        if(vm.filter.mergedFilter){
          filterData = vm.filter.mergedFilter.and.map(function(filter){return filter.columnId+' '+filter.op+' '+filter.value;});
        }

        if(vm.filter.quickFilter){
          filterData+= ','+ vm.filter.quickFilter.display;
        }

        //Clear the input after saving filter
        vm.filter.name = '';

        $gzAnalytics.eventSave('Grid ('+pairingId+') Filters', {label: 'filter name : ' + vm.filter.name +', filters : ' + JSON.stringify(filterData)});
        return serverFilter.data;
      }
    })
    .finally(() => {
      vm.sending = false;
    });
  }

  function cancel() {
    //Clear the input
    vm.filter.name = '';
    $gzAnalytics.eventClick('Grid ('+pairingId+') Filters');
    $mdDialog.cancel();
  }

  function disableSubmit() {
    return vm.editForm.$invalid || vm.sending || (vm.filter && vm.filter.name && vm.filter.name.trim() === '');
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/filters/save-dialog/save-dialog.controller.js